import { api } from '@/lib/api'
import type { Gate, StageRequirement, StageRequirementRequest } from './types'

export async function getContractGate(contractId: number): Promise<Gate> {
  const r = await api.get<Gate>(`/api/contracts/${contractId}/gate`)
  return r.data
}

type ListOptions = {
  stage?: string
  objectType?: 'contract' | 'annex'
  transition?: string
}

export async function listRequirementsByConfiguration(
  configurationCode: string,
  opts: ListOptions | string = {},
): Promise<StageRequirement[]> {
  const o: ListOptions = typeof opts === 'string' ? { stage: opts } : opts
  const params = new URLSearchParams()
  if (o.objectType) params.set('objectType', o.objectType)
  if (o.stage) params.set('stage', o.stage)
  if (o.transition) params.set('transition', o.transition)
  const qs = params.toString()
  const r = await api.get<StageRequirement[]>(
    `/api/configurations/${configurationCode}/stage-requirements${qs ? '?' + qs : ''}`,
  )
  return r.data
}

export async function createRequirement(configurationCode: string, payload: StageRequirementRequest): Promise<StageRequirement> {
  const r = await api.post<StageRequirement>(`/api/configurations/${configurationCode}/stage-requirements`, payload)
  return r.data
}

export async function deleteRequirement(id: number): Promise<void> {
  await api.delete(`/api/stage-requirements/${id}`)
}

// ----- product (element) stage requirements (FIELD only) -----

export async function listRequirementsByProduct(productCode: string, stage?: string): Promise<StageRequirement[]> {
  const qs = stage ? `?stage=${encodeURIComponent(stage)}` : ''
  const r = await api.get<StageRequirement[]>(`/api/products/${productCode}/stage-requirements${qs}`)
  return r.data
}

export async function createProductRequirement(productCode: string, payload: StageRequirementRequest): Promise<StageRequirement> {
  const r = await api.post<StageRequirement>(`/api/products/${productCode}/stage-requirements`, payload)
  return r.data
}
